import NotFoundImage from "../../images/pngs/notFound.png"
import { useNavigate } from 'react-router-dom';

function MobileRestricted() {

    const navigate = useNavigate();
    
    return (
        <div className='notFoundDiv'>
            <div className="notFoundImgDiv">
                <img src={NotFoundImage} alt="404 Error" />
            </div>
            <p>Please use Desktop to access this Resource!</p>
            <button style={{width: "fit-content", paddingRight: "20px", paddingLeft: "20px"}} onClick={()=> navigate("/")} className="modalButton submit">Back To Home</button>
        </div>
    )
}

export default MobileRestricted